if (!customElements.get('neu-glass-configurator')) {
  customElements.define('neu-glass-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      if (!this.querySelector('[data-drawing]')) return;
      this.words = JSON.parse(this.querySelector('[data-config-text]').textContent);
      this.abort = new AbortController();
      const preview = this.querySelector('.ngc-preview');
      const mobile = window.matchMedia('(max-width:749px)');
      const placePreview = () => {
        if (mobile.matches) this.querySelector('.ngc-group').after(preview);
        else this.querySelector('.ngc-layout').append(preview);
      };
      placePreview();
      mobile.addEventListener('change', placePreview, {signal:this.abort.signal});
      this.addEventListener('input', () => this.update(), {signal:this.abort.signal});
      this.addEventListener('change', () => this.update(), {signal:this.abort.signal});
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    field(key) { return this.querySelector(`[data-key="${key}"]${key === 'layout' ? ':checked' : ''}`); }
    value(key) { const field = this.field(key); return field?.disabled ? '' : field?.value || ''; }
    label(key) {
      const f = this.field(key);
      if (!f || f.disabled) return this.words.not_relevant;
      if (f.type === 'radio') return f.dataset.label;
      if (f.tagName === 'SELECT') return f.selectedOptions[0].textContent;
      if (f.type === 'checkbox') return f.checked ? this.words.yes : this.words.no;
      return f.value.trim() || this.words.missing;
    }
    show(selector, visible) {
      this.querySelectorAll(selector).forEach(group => {
        group.hidden = !visible;
        group.querySelectorAll('input,select').forEach(field => { field.disabled = !visible; });
      });
    }
    update() {
      const layout = this.value('layout');
      this.show('[data-door]', layout !== 'fixed');
      this.show('[data-panel]', ['left','right','both'].includes(layout));
      this.show('[data-transom]', this.value('transom') === 'yes');
      this.show('[data-ral]', this.value('colour') === 'custom');
      this.querySelector('[data-climate]').hidden = !['wine','pantry'].includes(this.value('use'));
      const width = Number(this.value('width')), height = Number(this.value('height'));
      const doorWidth = this.field('doorWidth'), transomHeight = this.field('transomHeight');
      const side = ['left','right','both'].includes(layout);
      doorWidth.setCustomValidity(!doorWidth.disabled && width > 0 && Number(doorWidth.value) > 0 && (side ? Number(doorWidth.value) >= width : Number(doorWidth.value) > width) ? this.words.door_error : '');
      transomHeight.setCustomValidity(!transomHeight.disabled && height > 0 && Number(transomHeight.value) >= height ? this.words.transom_error : '');
      this.querySelector('[data-selection]').textContent = this.label('layout') + (this.value('doorType') === 'double' ? ' · ' + this.label('doorType') : '');
      const keys = ['layout','use','width','height','doorWidth','transom','transomHeight','build','tint','bars','colour','ral','opening','closing','handle','sill','mount','measureHelp','doorType'];
      const labels = this.words.summary_labels.split('|');
      const list = this.querySelector('[data-summary]');
      list.replaceChildren();
      const summary = [];
      keys.forEach((key,i) => {
        const field = this.field(key);
        if (!field || field.disabled) return;
        let text = this.label(key);
        if (['width','height','doorWidth','transomHeight'].includes(key) && field.value) text += ' mm';
        summary.push(`${labels[i]}: ${text}`);
        {
          const row = document.createElement('div'), term = document.createElement('dt'), definition = document.createElement('dd');
          term.textContent = labels[i]; definition.textContent = text;
          row.append(term,definition);list.append(row);
        }
      });
      this.querySelector('[data-summary-input]').value = summary.join('\n');
      this.draw(layout, width, height);
    }
    draw(layout, measuredW, measuredH) {
      const svg = this.querySelector('[data-drawing]'); svg.replaceChildren();
      const element = (tag, attrs, text) => {
        const el = document.createElementNS('http://www.w3.org/2000/svg',tag);
        Object.entries(attrs).forEach(([k,v])=>el.setAttribute(k,String(v)));
        if (text) el.textContent = text;
        svg.append(el);return el;
      };
      const width = measuredW > 0 ? measuredW : (layout === 'single' ? 950 : 1900);
      const height = measuredH > 0 ? measuredH : 2100;
      const scale = Math.min(296/width,260/height), w=width*scale, h=height*scale, x=(420-w)/2, y=(310-h)/2+24;
      const stroke = {black:'#232321',white:'#fafaf8',grey:'#50565b',custom:'#8c7865',advice:'#232321'}[this.value('colour')];
      const glass = this.value('tint') === 'smoked' ? '#c2b7a6' : '#e3ebe9';
      const outline = {stroke, 'stroke-width':5, fill:glass};
      element('rect',{x:x-3,y:y-3,width:w+6,height:h+6,fill:'#cecbc4',rx:1});
      element('rect',{x,y,width:w,height:h,...outline});
      const transom = this.value('transom') === 'yes';
      let t=0;
      if(transom){
        const chosen=Number(this.value('transomHeight'));
        t=chosen>0 && chosen<height ? chosen*scale : h*.18;
        element('line',{x1:x,y1:y+t,x2:x+w,y2:y+t,stroke,'stroke-width':4});
      }
      let dx=x, dw=w;
      const chosenDW=Number(this.value('doorWidth'));
      if(['left','right','both'].includes(layout)) {
        dw=chosenDW>0 && chosenDW<width ? chosenDW*scale : w*(layout==='both' ? .56 : .7);
        const rest=w-dw;
        dx=layout==='left' ? x+rest : layout==='both' ? x+rest/2 : x;
        if(dx>x) element('line',{x1:dx,y1:y+t,x2:dx,y2:y+h,stroke,'stroke-width':4});
        if(dx+dw<x+w-.1) element('line',{x1:dx+dw,y1:y+t,x2:dx+dw,y2:y+h,stroke,'stroke-width':4});
      }
      const doors=layout==='double' || this.value('doorType')==='double' ? 2 : layout==='fixed' ? 0 : 1;
      if(doors===2) element('line',{x1:dx+dw/2,y1:y+t,x2:dx+dw/2,y2:y+h,stroke,'stroke-width':4});
      if(['three','six'].includes(this.value('bars'))){
        for(let i=1;i<3;i++)element('line',{x1:x,y1:y+t+(h-t)*i/3,x2:x+w,y2:y+t+(h-t)*i/3,stroke,'stroke-width':2.5});
        if(this.value('bars')==='six'){
          const leaves=doors===2 ? [[dx,dw/2],[dx+dw/2,dw/2]] : [[dx,dw]];
          leaves.forEach(([lx,lw])=>element('line',{x1:lx+lw/2,y1:y+t,x2:lx+lw/2,y2:y+h,stroke,'stroke-width':2.5}));
        }
      }
      if(doors){
        const leftHinge=this.value('opening').startsWith('left') || this.value('opening')==='advice';
        const handleX=doors===2 ? dx+dw/2-8 : leftHinge ? dx+dw-10 : dx+10;
        const cy=y+t+(h-t)*.52;
        element('line',{x1:handleX,y1:cy-9,x2:handleX,y2:cy+9,stroke,'stroke-width':4,'stroke-linecap':'round'});
        if(doors===2)element('line',{x1:dx+dw/2+8,y1:cy-9,x2:dx+dw/2+8,y2:cy+9,stroke,'stroke-width':4,'stroke-linecap':'round'});
        if(this.value('opening')!=='advice' && doors===1){
          const hingeX=leftHinge?dx:dx+dw, farX=leftHinge?dx+dw:dx;
          element('path',{d:`M${farX},${y+t+5} L${hingeX},${cy} L${farX},${y+h-5}`,fill:'none',stroke,'stroke-width':1,'stroke-dasharray':'4 5',opacity:.55});
        }
      }
      const dim={stroke:'#8c8980','stroke-width':1};
      const bottom=y+h+22;
      element('path',{d:`M${x},${bottom-5}v10 M${x},${bottom}H${x+w} M${x+w},${bottom-5}v10`,...dim,fill:'none'});
      element('text',{x:210,y:bottom+22,'text-anchor':'middle',fill:'#55534e','font-size':12},measuredW>0?`${measuredW} mm`:this.words.width);
      const xx=x+w+19;
      element('path',{d:`M${xx-5},${y}h10 M${xx},${y}V${y+h} M${xx-5},${y+h}h10`,...dim,fill:'none'});
      element('text',{x:xx+14,y:y+h/2,'text-anchor':'middle',fill:'#55534e','font-size':12,transform:`rotate(-90 ${xx+14} ${y+h/2})`},measuredH>0?`${measuredH} mm`:this.words.height);
    }
  });
}
